/**
 * Created by fworld on 2019/9/27.
 */
const maintainSet = [
    {
        name: 'delivery.devices.maintainSet',
        path: 'maintainSet',
        meta: {title: '维护设置'},
        component: () => import('@/pages/Delivery/Device/MaintainSet'),
    },
    {
        name: 'delivery.devices.maintainSet.detail',
        path: 'maintainSet/detail',
        meta: {title: '维护信息详情'},
        component: () => import('@/pages/Delivery/Device/MaintainSet/detail'),
    },

]

export default maintainSet